function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { string } from "prop-types";
import { components } from "react-select";
import classNamesMaker from "classnames";
var Group = components.Group;
export var GroupCheckbox = function GroupCheckbox(props) {
  var className = props.className;
  var groupClassName = classNamesMaker(className, "jds-GroupedCheckbox");
  return /*#__PURE__*/React.createElement(Group, _extends({}, props, {
    className: groupClassName
  }));
};
GroupCheckbox.propTypes = {
  className: string
};
GroupCheckbox.defaultProps = {
  className: null
};